export enum ContentType {
  TEXT,
  VOICE,
  PHOTO,
  DOCUMENT,
  VIDEO,
  AUDIO,
}

export enum CommissionRateType {
  CO_PRODUCTION = 'CO_PRODUCTION',
  AFFILIATION = 'AFFILIATION',
  VIB_ROYALTIES = 'VIB_ROYALTIES',
}
export const commissionTypes = {
  [CommissionRateType.CO_PRODUCTION]: 'Co-produção',
  [CommissionRateType.AFFILIATION]: 'Afiliação',
  [CommissionRateType.VIB_ROYALTIES]: 'Indicação',
};

export type GenericResponse = {
  success: boolean;
};
